<template>
  <div>
    <filtroLote :atualizarLkpLote="atualizarLkpLote" @filtroLote="buscarLotes" @limparGrid="lotes = []"/>

    <grid :colunas="colunas" :dados="lotes" :carregando="carregando">
      
      <template #cell(status)="data">
        <span class="badge badge-pill font-size-12"
             :class="{
               'badge-soft-danger' : data.value === 'PENDENTE',
               'badge-soft-success': data.value === 'CONCLUÍDO',
               'badge-soft-warning': data.value === 'PARCIAL',
             }"
        >
          {{ data.value }}
        </span>
      </template>

      <template #cell(conclusao)="data">
        <div v-if="data.item.porcentagem_conclusao === 0" style="position: relative;">
          <b-progress :max="100" height="1.2rem" style="background-color: #dbdbdb;">
            <div
              class="text-center fw-bold"
              style="position: absolute; top: 0; left: 0; right: 0; height: 100%; display: flex; align-items: center; justify-content: center;"
            >
              {{ data.item.porcentagem_conclusao }}%
            </div>
          </b-progress>
        </div>

        <b-progress v-else :max="100" height="1.2rem" style="background-color: #dbdbdb;">
          <b-progress-bar
            :value="data.item.porcentagem_conclusao"
            :variant="corDaPorcentagemConclusao(data.item.porcentagem_conclusao)"
            class="fw-bold"
            animated
          >
            {{ data.item.porcentagem_conclusao }}%
          </b-progress-bar>
        </b-progress>
      </template>

      <template #cell(acoes)="data">
        <b-button size="sm" variant="primary" class="me-1" :disabled="loadingAcoes" data-tooltip="Visualizar" data-tooltip-location="left" @click="visualizarProjetosLote(data.item)">
          <i class="mdi mdi-eye"></i>
        </b-button>
        
        <b-button v-if="data.item.libera_exclusao" size="sm" variant="danger" data-tooltip="Excluir" :disabled="loadingAcoes" data-tooltip-location="left" @click="excluirLote(data.item)">
          <i class="mdi mdi-trash-can"></i>
        </b-button>
      </template>

    </grid>
  </div>
</template>

<script>
import filtroLote from "@/components/astec/projetos/lotesImportacao/filtroLote";
import grid       from "@/components/grid";
import Swal       from "sweetalert2";

export default {
  components:{ filtroLote, grid },
  data() {
    return {
      carregando      : true,
      loadingAcoes    : false,
      liberaExclusao  : false,
      atualizarLkpLote: false,
      lotes           : [],
      colunas: [
        { key: "ds_astec_integracao_lote", label: "Lote"                  , sortable: true },
        { key: "dt_importacao"           , label: "Data/Hora Importação"  , sortable: true },
        { key: "qt_projetos"             , label: "Qtd Projetos"          , sortable: true },
        { key: "nm_arquivo"              , label: "Nome Arquivo Importado", sortable: true },
        { key: "status"                  , label: "Status"                , sortable: true },
        { key: "conclusao"               , label: "Porcentagem Conclusão" , sortable: true },
        { key: "acoes"                   , label: "Ações"                                  },
      ],
    };
  },
  methods: {
    async buscarLotes(filtro){
      this.carregando = true;

      await this.$http.get("/api/astec/projetos/importarProjetos/getLotes", {
        params: {...filtro}
      })
      .then((response) => {
        
        this.lotes          = response.data.lotes;
        this.liberaExclusao =  response.data.lotes.libera_exclusao;

        this.$tools.fecharMenu();
      
      })
      .catch((error) =>{
      
        this.$tools.alerta(error.response.data.message, "error");
      
      })
      .finally(() =>{

        this.carregando = false;
        
      });
    },
    visualizarProjetosLote(dados){
      localStorage.setItem('sqAstecIntegracaoLote', dados.sq_astec_integracao_lote);

      this.$router.push('/astec/projetos/lotesImportacao/projetosLote');
    },
    excluirLote(dados){
      const mensagem = dados.qtd_completos > 0 
                     ? `Existe(m) ${dados.qtd_completos} projeto(s) COMPLETO(S) no lote ${dados.sq_astec_integracao_lote}. Tem certeza que deseja excluir o lote e seu(s) lançamento(s)? Esta ação não pode ser desfeita.`
                     : `Você realmente deseja excluir o lote ${dados.sq_astec_integracao_lote} e seu(s) lançamento(s)? Esta ação não pode ser desfeita.`;  

      Swal.fire({
        title             : "Tem certeza?",
        text              : mensagem,
        icon              : "warning",
        showCancelButton  : true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor : "#d33",
        confirmButtonText : "Sim, excluir!",
        cancelButtonText  : "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingAcoes = true;

          const sqAstecIntegracaoLote = dados.sq_astec_integracao_lote;

          this.$http.delete(`/api/astec/projetos/importarProjetos/excluirLote/${sqAstecIntegracaoLote}`)
          .then((response) => {
            Swal.fire({
              icon : "success",
              title: "Sucesso",
              text : response.data.message,
            });

            const filtro = {cd_pessoa: dados.cd_pessoa};

            this.atualizarLkpLote = true;
            this.buscarLotes(filtro)
          })
          .catch((error) => {

            if(error.response.data.message != ""){
              this.$tools.alerta(error.response.data.message, "error");
            } else {
              this.$tools.alerta("Erro ao excluir lote", "error");
            }

          })
          .finally(() => {

            this.loadingAcoes     = false;
            this.atualizarLkpLote = false;

          });
        }
      });
    },
    corDaPorcentagemConclusao(valor) {
      if (valor < 50) {
        return "danger";
      }else if (valor >= 50 && valor < 100) {
        return "warning";
      }else {
        return "success";
      }
    },
  }
};
</script>
